export default {
  workerUrl: `https://${process.env.VUE_APP_WORKER_HOST}`,
};
